export enum TokenSymbol {
  BNB = 'BNB',
  ETH = 'ETH',
  BUSD = 'BUSD',
  USDT = 'USDT',
  USDC = 'USDC',
  AUCTION = 'AUCTION',
  BTC = 'BTC',
  HT = 'HT',
  MATIC = 'MATIC',
  Solana = 'SOLANA',
}

export enum ChainSymbol {
  BSC = 'BSC',
  ETH = 'ETH',
  HECO = 'HECO',
  Polygon = 'POLYGON',
}
